<template>
    <div>
        <div class="div d-flex justify-content-between">
            <div>
                <span v-if="userInfo"
                    >Logged in as
                    {{ `${userInfo.first_name} ${userInfo.last_name}`
                    }}{{ `<${userInfo.email}>` }}</span
                >
                <span v-else
                    ><a href="/login">Login</a> first to leave a comment on this
                    template.</span
                >
            </div>
            <div v-if="userInfo">
                <a-button
                    type="link"
                    size="small"
                    @click="
                        () => {
                            resetForm();
                            setModalVisible = true;
                        }
                    "
                >
                    Leave your comment
                </a-button>
            </div>
        </div>
        <div
            class="mt-4 ant-list ant-list-split ant-list-something-after-last-item"
        >
            <a-spin :spinning="fetching">
                <ul class="ant-list-items" v-if="commentList.length > 0">
                    <li
                        class="ant-list-item"
                        v-for="item in commentList"
                        :key="item.key"
                    >
                        <div class="ant-list-item-meta">
                            <div class="ant-list-item-meta-avatar">
                                <span
                                    class="ant-avatar ant-avatar-circle ant-avatar-image"
                                >
                                    <img
                                        :src="item.user.profile_picture"
                                        :alt="item.user.full_name"
                                    />
                                </span>
                            </div>
                            <div class="ant-list-item-meta-content">
                                <h4 class="ant-list-item-meta-title">
                                    <a href="#" class="mr-4">{{
                                        item.user.full_name
                                    }}</a>
                                </h4>
                                <div class="ant-list-item-meta-description">
                                    <a-rate
                                        :value="item.rating"
                                        disabled
                                        style="font-size: 15px !important"
                                    />
                                    <span
                                        class="ml-5"
                                        style="
                                            color: rgba(0, 0, 0, 0.4);
                                            font-style: italic;
                                            font-size: 12px;
                                        "
                                    >
                                        <i class="ti-alarm-clock"></i>
                                        {{ item.created_at_diff }}
                                    </span>
                                </div>
                                <div class="ant-list-item-meta-description">
                                    {{ item.comment }}
                                </div>
                            </div>
                        </div>
                        <ul class="ant-list-item-action">
                            <li v-if="userInfo && userInfo.id === item.user.id">
                                <a-popconfirm
                                    title="Are you sure delete comment?"
                                    ok-text="Yes"
                                    cancel-text="No"
                                    @confirm="confirmCommentDelete(item.id)"
                                >
                                    <a
                                        href="#"
                                        style="color: darkred"
                                        :disabled="item.id === deletingId"
                                        >Delete</a
                                    >
                                </a-popconfirm>
                            </li>
                        </ul>
                    </li>
                </ul>
                <h5 class="text-center mt-5" v-if="commentList.length === 0">
                    No comments found. Be the first person to comment.
                </h5>
            </a-spin>
        </div>
        <div class="text-center mt-4" v-if="meta && meta.last_page > 1">
            <a-pagination
                :pageSize="10"
                :current="meta.current_page"
                :total="meta.total"
                show-less-items
                @change="onChangePage"
                size="small"
            />
        </div>

        <!-- Leave a comment modal -->
        <a-modal
            :visible="setModalVisible"
            title="Leave your comment with rating"
            centered
            @onOk="saveComment"
            okText="Save Comment"
            cancelText="Cancel"
            :maskClosable="false"
        >
            <div class="form-group">
                <a-textarea
                    v-model="form.comment"
                    show-count
                    :maxlength="200"
                    placeholder="Leave your comment (Max 200 character)"
                    :autoSize="{ minRows: 4, maxRows: 6 }"
                    @change="() => (error.comment = null)"
                    :class="{
                        'ant-form-item-has-error': error && error.comment,
                    }"
                />
                <div
                    role="alert"
                    class="ant-form-item-explain-error"
                    v-if="error && error.comment"
                >
                    {{ error.comment[0] }}
                </div>
            </div>
            <div class="form-group">
                <a-rate v-model="form.rating" />
                <p
                    style="
                        margin-bottom: 0;
                        margin-top: 0;
                        font-size: 15px;
                        color: rgb(0, 0, 0, 0.58);
                    "
                >
                    Rate this template
                </p>
            </div>

            <template #footer>
                <a-button
                    key="back"
                    @click="
                        () => {
                            resetForm();
                            setModalVisible = false;
                        }
                    "
                >
                    Cancel
                </a-button>
                <a-button
                    key="button"
                    type="primary"
                    :loading="saving"
                    @click="saveComment"
                >
                    Save Comment
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import { HTTP } from "../api";
export default {
    props: ["template", "user"],
    data() {
        return {
            initLoading: false,
            commentList: [],
            fetching: false,
            meta: {},
            userInfo: null,
            deletingId: null,
            setModalVisible: false,
            saving: false,
            form: {
                rating: 0,
                comment: "",
            },
            error: {},
        };
    },
    methods: {
        async fetchComments() {
            this.fetching = true;
            try {
                let qs = "";
                if (this.meta && this.meta.current_page > 1) {
                    qs = `?page=${this.meta.current_page}`;
                }
                const { data } = await HTTP.get(
                    `templates/${this.template}/comments${qs}`
                );
                this.commentList = data?.data;
                this.meta = data?.meta;
            } catch (error) {
                this.$notification.error({
                    message: "Failed to fetch template comments",
                });
            }
            this.fetching = false;
        },
        async saveComment() {
            this.saving = true;
            this.error = {};
            try {
                const payload = {
                    ...this.form,
                    template_id: this.template,
                };
                await HTTP.post(`/comments`, payload);
                this.resetForm();
                this.fetchComments();
                this.setModalVisible = false;
                this.$notification.success({
                    message: "Comment added",
                });
            } catch (error) {
                if (error?.response?.status === 422) {
                    this.error = error?.response?.data?.errors;
                } else {
                    this.$notification.success({
                        message: "Failed to add comment",
                    });
                }
            }
            this.saving = false;
        },
        onChangePage(page) {
            this.meta.current_page = page;
            this.fetchComments();
        },
        async confirmCommentDelete(id) {
            this.deletingId = id;
            try {
                await HTTP.delete(`comments/${id}`);
                this.fetchComments();
                this.$notification.success({
                    message: "Comment removed successfully!",
                });
            } catch (error) {}
            this.deletingId = null;
        },
        resetForm() {
            this.form.rating = 0;
            this.form.comment = "";
        },
    },
    created() {
        this.fetchComments();
        if (this.user && this.user !== "") {
            this.userInfo = JSON.parse(this.user);
        }
    },
};
</script>

<style scoped>
.ant-form-item-has-error {
    background: #fff !important;
    border: 1px solid #ff4d4f !important;
}
.ant-form-item-explain-error {
    color: #ff4d4f !important;
}
</style>
